import { useRef } from 'react';
import { InputAdornment, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import IconButton from '@material-ui/core/IconButton';
import { FilterNoneRounded } from '@material-ui/icons';
import useUiToasts, { createToastConfig, SUCCESS } from '../../stores/ToastStore';

const useStyles = makeStyles(() => ({
    copyToInput: {
        '& .MuiInputBase-root': {
            fontFamily: 'Monospace',
            fontSize: 12,
        },
    },
}));

export default function NgpCopyToClipboard({ label, value, inputProps, multiline = false }) {
    const classes = useStyles();
    const copyFieldRef = useRef(null);
    const [, uiToastActions] = useUiToasts();

    const handleCopyToClipboard = (e) => {
        copyFieldRef.current.select();
        document.execCommand('copy');
        uiToastActions.createToast(createToastConfig(SUCCESS, i18n._(t`Copied to clipboard!`)));
        // This is just personal preference.
        // I prefer to not show the whole text area selected.
        e.target.focus();
    };

    return (
        <TextField
            multiline={multiline}
            variant="outlined"
            margin="none"
            size="small"
            label={label}
            value={value}
            inputRef={copyFieldRef}
            inputProps={inputProps}
            className={classes.copyToInput}
            /* eslint-disable-next-line react/jsx-no-duplicate-props */
            InputProps={{
                readOnly: true,
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton onClick={handleCopyToClipboard} title={t`Copy to clipboard`}>
                            <FilterNoneRounded />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
}
